import { render } from "./IndexOne.vue?vue&type=template&id=afb7287c"
import script from "./IndexOne.vue?vue&type=script&lang=js"
export * from "./IndexOne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__